export { StudentHomePage, type StudentHomePageProps } from "./StudentHomePage"
